export default __webpack_public_path__ + "static/media/reddit_osadz.be33ff1b.webp";